var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.navLogoType ? 'h-10' : 'flex flex-col justify-center'},[(_vm.navLogoType)?_c('img',{staticClass:"h-full",attrs:{"src":_vm.logoPath,"alt":_vm.altText,"srcset":""}}):_c('div',{staticClass:"mt-2",domProps:{"innerHTML":_vm._s(_vm.navLogoLabel)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }